import { UserRoles } from '@/enums';
import { Orders } from '@/modules/orders/types';

// TO DO: уточнить роли, которые имеют доступ к странице
const access_roles = {
  [Orders.Pages.ORDERS]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
  ],
  [Orders.Pages.ORDER_DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
  ],
  [Orders.Pages.ORDERS_INVOICES]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
  ],
};

export default access_roles;
